module.exports = __webpack_public_path__ + "static/copyselector-678fd3cbf02eae2541ecd73979df2f88.png";